import React from 'react'
import ReactDOM from 'react-dom/client'

//removing no conflict breaks WYSIWYG
import ld from 'lodash'
const __ = ld.noConflict()

// import get from 'lodash/get'
// import each from 'lodash/each'

import classNames from 'classnames'

import styles from './index.module.sass'

import Body from './components/layout/body'
import Header from './components/site/header'
import Footer from './components/site/footer'

import AnnouncementContextProvider from './components/context/announcementContext'

import library from './components/library'

function App({pageData, navData, globalData}) {
	
	const headerStyle = __.get(pageData, 'page_settings.header_style')
	const layoutControls = __.get(pageData, 'page_settings.layout_controls')
	
	const renderedComponents = []

	__.each(pageData.components, (component, i) => {
		const type = component.name

		let renderedComponent = null
		if (library[type]) {
			const Component = library[type];
			renderedComponent = <Component key={`component_${type}_${i}`} {...component} />
		} else {
			console.log('Component type not found in library')
		}

		if (renderedComponent) {
			renderedComponents.push(renderedComponent)
		}
	})

	return <div className={classNames(styles.app, styles[`header_${headerStyle}`])}>
		<AnnouncementContextProvider>
			{layoutControls != 'footer_only' &&  <Header />}
			<Body>{renderedComponents}</Body>
			{layoutControls != 'header_only' && <Footer />}
		</AnnouncementContextProvider>
	</div>
}

const globalData = JSON.parse(document.getElementById('global-data').innerHTML)
const navData = JSON.parse(document.getElementById('nav-data').innerHTML)
const pageData = JSON.parse(document.getElementById('page-data').innerHTML)
const root = ReactDOM.createRoot(document.getElementById("root"))

root.render(
	<React.StrictMode>
		<App pageData={pageData} navData={navData} globalData={globalData} />
	</React.StrictMode>
)